export const chunk = (arr: any, size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );

  export const newLineText = (text:string) => {
    return text.split('\n');
  }